import MyBreadcrumbItem from '../breadcrumb/breadcrumb-item';

/* istanbul ignore next */
MyBreadcrumbItem.install = function(Vue) {
  Vue.component(MyBreadcrumbItem.name, MyBreadcrumbItem);
};

export default MyBreadcrumbItem;


// WEBPACK FOOTER //
// ./src/components/common/breadcrumb-item/index.js